module.exports = __webpack_public_path__ + "img/71.10.pH.8e626289.png";